import React from 'react'
import Overview from 'components/insightContent/visualization/Overview'
import { InsightContentSettingType } from 'components/insightContent/types'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import useCrosstabData from 'components/widget/CrosstabWidgets/share/Crosstab/useCrosstabData'
import Title from './Title'
import resolveSum from '../utils/sumResolver'
import selectEntireColumn from '../utils/columnSelector'
import selectEntireRow from '../utils/rowSelector'
import resolveShare from '../utils/shareResolver'

const ShareOfRows = ({
  detailSetting,
  widgetId,
  isAudienceQuery
}: {
  detailSetting: InsightContentSettingType
  widgetId: number
  isAudienceQuery: boolean
}) => {
  const { crossTabs } = useCrosstabData(widgetId, isAudienceQuery)

  const selectedRow = selectEntireRow(detailSetting, crossTabs)
  const selectedItem = selectEntireColumn(detailSetting, selectedRow)

  const sumOfSelectedRow = resolveSum(selectedRow)
  const selectedItemValue = resolveSum(selectedItem)

  return (
    <UnexpectedErrorBoundary>
      <Overview
        title={<Title />}
        count={resolveShare(sumOfSelectedRow, selectedItemValue)}
        status="succeeded"
      />
    </UnexpectedErrorBoundary>
  )
}

export default ShareOfRows
